import { DatePicker, Space } from "antd";
import trans from "./../../../Languages/Languages";
import { useState, useEffect } from "react";
import { Button, Card, message, Form } from "antd";
import API from "../../../API";
import moment from "moment";
import { usePageContext } from "../../../Context/PageContext";

const AdmissionDeadline = () => {
  message.config({ top: 80 });

  const admissionDate = [
    { key: "fall", name: trans.AutumnFallsemester },
    { key: "spring", name: trans.Springsemester },
  ];

  const [admissionDeadlineData, setAdmissionDeadlineData] = useState();
  const [toRefreshData, setToRefreshData] = useState(false);
  const [loading, setLoading] = useState(true);

  const [pageData, setPageData] = useState(null);
  const [autumnData, setAutumnData] = useState(null);
  const [springData, setSpringData] = useState(null);

  const [autumnStart, SetAutumnStart] = useState(null);
  const [autumnLastDate, setAutumnLastDate] = useState(null);
  const [autumnFinalExams, setAutumnFinalExams] = useState(null);
  const [springStart, setSpringStart] = useState(null);
  const [springLastDate, setSpringLastDate] = useState(null);
  const [springFinalExams, setSpringFinalExams] = useState(null);

  const [isRenaming, setIsRenaming] = useState(false);
  const [renameValue, setRenameValue] = useState("");
  const [editingSeason, setEditingSeason] = useState(null);
  const [renameSeasonValue, setRenameSeasonValue] = useState("");

  const [editingDateKey, setEditingDateKey] = useState(null);
  const [renameDateValue, setRenameDateValue] = useState("");

  const [showContextMenu, setShowContextMenu] = useState(false);
  const [contextMenuPos, setContextMenuPos] = useState({ x: 0, y: 0 });
  const [contextMenuTarget, setContextMenuTarget] = useState(null); // 'main', 'season', or 'dateLabel'
  const [contextMenuSeasonKey, setContextMenuSeasonKey] = useState(null);

  const { triggerRefresh } = usePageContext();

  useEffect(() => {
    setLoading(true);
    const init = async () => {
      try {
        const res = await API.get("/admin/admissions/deadline");
        const {
          deadline_data,
          general,
          spring,
          autumn,
          autumnStart,
          autumnLastDate,
          autumnFinalExams,
          springStart,
          springLastDate,
          springFinalExams,
        } = res.data;

        setPageData(general);
        setRenameValue(general?.title);
        setAutumnData(autumn);
        setSpringData(spring);

        SetAutumnStart(autumnStart);
        setAutumnLastDate(autumnLastDate);
        setAutumnFinalExams(autumnFinalExams);
        setSpringStart(springStart);
        setSpringLastDate(springLastDate);
        setSpringFinalExams(springFinalExams);

        setAdmissionDeadlineData(deadline_data);
      } catch {
        message.error("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };
    init();
  }, [toRefreshData]);

  useEffect(() => {
    const handleClickOutside = () => setShowContextMenu(false);
    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);

  const handleSave = (values) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("fall_starting_date", moment(values.fallStartingDate).format("YYYY-MM-DD"));
    formData.append("spring_starting_date", moment(values.springStartingDate).format("YYYY-MM-DD"));
    formData.append("fall_last_date", moment(values.fallLastDate).format("YYYY-MM-DD"));
    formData.append("spring_last_date", moment(values.springLastDate).format("YYYY-MM-DD"));
    formData.append("fall_final_exams", moment(values.fallFinalExam).format("YYYY-MM-DD"));
    formData.append("spring_final_exams", moment(values.springFinalExam).format("YYYY-MM-DD"));

    API.post("/admin/admissions/deadline/update", formData)
      .then(() => {
        setToRefreshData(!toRefreshData);
        message.success("Section Updated Successfully", 3);
      })
      .catch(() => {
        message.error("Something went wrong, please try again", 3);
      })
      .finally(() => setLoading(false));
  };

  const handleRenameSubmit = async () => {
    try {
      await API.put(`/admin/pages/slug/${pageData.slug}`, { title: renameValue });
      setPageData((prev) => ({ ...prev, title: renameValue }));
      setIsRenaming(false);
      triggerRefresh();
    } catch (err) {
      message.error("Rename failed");
    }
  };

  const handleSeasonRenameSubmit = async (season) => {
    const seasonPage = season === "fall" ? autumnData : springData;
    try {
      await API.put(`/admin/pages/slug/${seasonPage.slug}`, { title: renameSeasonValue });
      if (season === "fall") {
        setAutumnData((prev) => ({ ...prev, title: renameSeasonValue }));
      } else {
        setSpringData((prev) => ({ ...prev, title: renameSeasonValue }));
      }
      setEditingSeason(null);
    } catch (err) {
      message.error("Rename failed");
    }
  };

  const handleDateRenameSubmit = async (labelObj) => {
    
    try {
      await API.put(`/admin/pages/slug/${labelObj?.slug}`, { title: renameDateValue });
      const slugMap = {
        [autumnStart?.slug]: SetAutumnStart,
        [autumnLastDate?.slug]: setAutumnLastDate,
        [autumnFinalExams?.slug]: setAutumnFinalExams,
        [springStart?.slug]: setSpringStart,
        [springLastDate?.slug]: setSpringLastDate,
        [springFinalExams?.slug]: setSpringFinalExams,
      };
  
      const updater = slugMap[labelObj?.slug];
      if (updater) {
        updater((prev) => ({ ...prev, title: renameDateValue }));
      }
      setEditingDateKey(null);
    } catch {
      message.error("Rename failed");
    }
  };

  const handleContextRename = () => {
    if (contextMenuTarget === "main") {
      setIsRenaming(true);
    } else if (contextMenuTarget === "season") {
      setEditingSeason(contextMenuSeasonKey);
    } else if (contextMenuTarget === "dateLabel") {
      setEditingDateKey(contextMenuSeasonKey);
    }
    setShowContextMenu(false);
  };

  const renderEditableLabel = (labelObj, key) => (
    <div
      className="f-12 fw-500 ad-date-m"
      onDoubleClick={() => {
        setEditingDateKey(key);
        setRenameDateValue(labelObj?.title);
      }}
      onContextMenu={(e) => {
        e.preventDefault();
        setContextMenuTarget("dateLabel");
        setContextMenuSeasonKey(key);
        setRenameDateValue(labelObj?.title);
        setContextMenuPos({ x: e.clientX, y: e.clientY });
        setShowContextMenu(true);
      }}
    >
      {editingDateKey === key ? (
        <input
          type="text"
          value={renameDateValue}
          autoFocus
          onChange={(e) => setRenameDateValue(e.target.value)}
          onBlur={() => handleDateRenameSubmit(labelObj)}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleDateRenameSubmit(labelObj);
          }}
          style={{ padding: "2px 6px", fontSize: "14px" }}
        />
      ) : (
        labelObj?.title
      )}
    </div>
  );

  return (
    <div className="pages-container admission-deadline">
      <Card loading={loading} bordered={false}>
        <div className="content-wrapper">
          {/* Main Title */}
          <div style={{ position: "relative" }}>
            <div
              className="fw-600 mb-2"
              onDoubleClick={() => setIsRenaming(true)}
              onContextMenu={(e) => {
                e.preventDefault();
                setContextMenuTarget("main");
                setContextMenuPos({ x: e.clientX, y: e.clientY });
                setShowContextMenu(true);
              }}
            >
              {isRenaming ? (
                <input
                  type="text"
                  value={renameValue}
                  autoFocus
                  onChange={(e) => setRenameValue(e.target.value)}
                  onBlur={handleRenameSubmit}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleRenameSubmit();
                  }}
                  style={{ padding: "2px 6px", fontSize: "14px" }}
                />
              ) : (
                pageData?.title || "Loading..."
              )}
            </div>
          </div>

          {showContextMenu && (
            <ul
              style={{
                position: "fixed",
                top: contextMenuPos.y,
                left: contextMenuPos.x,
                backgroundColor: "white",
                border: "1px solid #ccc",
                borderRadius: 4,
                listStyle: "none",
                padding: "5px 10px",
                margin: 0,
                zIndex: 1000,
                cursor: "pointer",
                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
              }}
              onClick={handleContextRename}
              onMouseLeave={() => setShowContextMenu(false)}
            >
              <li>{trans.Rename}</li>
            </ul>
          )}

          {admissionDeadlineData && (
            <Form onFinish={handleSave}>
              {admissionDate.map((ad) => {
                const seasonKey = ad.key;
                const seasonData = seasonKey === "fall" ? autumnData : springData;

                return (
                  <div className="bg-content-container" key={seasonKey}>
                    <div
                      className="f-12 fw-500 h-heading"
                      onDoubleClick={() => {
                        setEditingSeason(seasonKey);
                        setRenameSeasonValue(seasonData?.title);
                      }}
                      onContextMenu={(e) => {
                        e.preventDefault();
                        setContextMenuTarget("season");
                        setContextMenuSeasonKey(seasonKey);
                        setRenameSeasonValue(seasonData?.title);
                        setContextMenuPos({ x: e.clientX, y: e.clientY });
                        setShowContextMenu(true);
                      }}
                    >
                      {editingSeason === seasonKey ? (
                        <input
                          type="text"
                          value={renameSeasonValue}
                          autoFocus
                          onChange={(e) => setRenameSeasonValue(e.target.value)}
                          onBlur={() => handleSeasonRenameSubmit(seasonKey)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") handleSeasonRenameSubmit(seasonKey);
                          }}
                          style={{ padding: "2px 6px", fontSize: "14px" }}
                        />
                      ) : (
                        seasonData?.title
                      )}
                    </div>

                    <div className="d-flex justify-content-start events-date-time">
                      <div className="accordion-detail p-date date-mr">
                        {renderEditableLabel(
                          seasonKey === "fall" ? autumnStart : springStart,
                          `${seasonKey}Start`
                        )}
                        <Space direction="vertical">
                          <Form.Item
                            name={`${seasonKey}StartingDate`}
                            initialValue={moment(admissionDeadlineData[`${seasonKey}_starting_date`])}
                          >
                            <DatePicker />
                          </Form.Item>
                        </Space>
                      </div>

                      <div className="accordion-detail p-date date-mr">
                        {renderEditableLabel(
                          seasonKey === "fall" ? autumnLastDate : springLastDate,
                          `${seasonKey}LastDate`
                        )}
                        <Space direction="vertical">
                          <Form.Item
                            name={`${seasonKey}LastDate`}
                            initialValue={moment(admissionDeadlineData[`${seasonKey}_last_date`])}
                          >
                            <DatePicker />
                          </Form.Item>
                        </Space>
                      </div>

                      <div className="accordion-detail p-date">
                        {renderEditableLabel(
                          seasonKey === "fall" ? autumnFinalExams : springFinalExams,
                          `${seasonKey}FinalExams`
                        )}
                        <Space direction="vertical">
                          <Form.Item
                            name={`${seasonKey}FinalExam`}
                            initialValue={moment(admissionDeadlineData[`${seasonKey}_final_exams`])}
                          >
                            <DatePicker />
                          </Form.Item>
                        </Space>
                      </div>
                    </div>
                  </div>
                );
              })}

              <Button className="btn-save-changes" type="primary" htmlType="submit">
                {trans.Save}
              </Button>
            </Form>
          )}
        </div>
      </Card>
    </div>
  );
};

export default AdmissionDeadline;
